import { FC } from 'react';
import { Box, BoxProps, Flex } from '@chakra-ui/react';
import { ICON_BY_NAME } from '../Icons/Icon';
import { CbNotificationBubble } from '../CbNotificationBubble';
export interface CbNotificationAlertBellProps extends BoxProps {
  count?: number;
  href?: string;
}
export const CbNotificationAlertBell: FC<CbNotificationAlertBellProps> = ({
  count,
  href,
  ...props
}) => {
  return <Flex as="a" href={href} {...props} data-sentry-element="Flex" data-sentry-component="CbNotificationAlertBell" data-sentry-source-file="CbNotificationAlertBell.tsx">
      <ICON_BY_NAME.notifications color="white" height="24px" width="24px" data-sentry-element="unknown" data-sentry-source-file="CbNotificationAlertBell.tsx" />
      <Box position="relative" transform="translateX(-30%)" bottom={1} data-sentry-element="Box" data-sentry-source-file="CbNotificationAlertBell.tsx">
        <CbNotificationBubble count={count} backgroundImage="linear-gradient(150deg, #B182EA 10%, #FF3364 100%)" data-sentry-element="CbNotificationBubble" data-sentry-source-file="CbNotificationAlertBell.tsx" />
      </Box>
    </Flex>;
};